module.exports = __webpack_public_path__ + "img/m2.c663c38f.png";